export function isPhoneNumberCorrect(phoneNumber: string) {
  return [10, 11].includes(phoneNumber.length) && phoneNumber.startsWith("010")
}

export function checkPassword(password: string) {
  const bad = (message: string) => ({
    isGoodPassword: false,
    passwordErrorMessage: message,
  })
  if (password.includes("\n"))
    return bad("비밀번호에 개행문자가 들어갈 수 없습니다.")
  if (password.includes(" "))
    return bad("비밀번호에 공백문자가 들어갈 수 없습니다.")
  if (password.includes("\t"))
    return bad("비밀번호에 공백문자가 들어갈 수 없습니다.")
  if (password.length < 8)
    return bad("비밀번호는 최소 8자 이상으로 설정해주세요.")
  if (password.length > 32) return bad("비밀번호는 최대 32자까지만 가능합니다.")
  if (/[^0-9a-zA-Z{}\[\]\/?.,;:|)*~`!^\-_+<>@#$%&\\=('"]/.test(password))
    return bad("영문, 숫자, 키보드 내 특수문자만 입력 가능합니다.")
  const count = [
    /[0-9]/.test(password),
    /[a-zA-Z]/.test(password),
    /[^[0-9a-zA-Z]/.test(password),
  ].filter((v) => v).length
  if (count < 2)
    return bad("영문, 숫자, 특수문자 중 두 개 이상이 조합되어야 합니다.")
  return { isGoodPassword: true, passwordErrorMessage: "" }
}
